<template>
  <div class="btn_container">

    <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
      <template slot="button-content">
        <span class="icon-menu3x3"><span class="visibility_hide">Menu</span></span>
      </template>
      <b-dropdown-item :to="{name:'programGuide'}">Program Guide View</b-dropdown-item>
      <!--<b-dropdown-item disabled>Edit</b-dropdown-item>-->
      <b-dropdown-item @click="printScreen()">Print</b-dropdown-item>
      <b-dropdown-item v-if="canExportStream" @click="exportStream">Export To CSV</b-dropdown-item>
    </b-dropdown>

    <b-btn v-if="showEditButton" @click="editStreamClicked">{{planStreamLabel}}</b-btn>

    <template v-if="isAdvisorNotesEnabled && channels.length > 0">
      <b-btn @click.stop='openAdvisorNotesDropDown'
        id="advisorNotesDropDown"
        class="btn_ic btn_notes ico-notes"
        aria-label="advisor notes">
      </b-btn>

      <div id="advisorNotesMenuPopup" class="lg_menu_popup menu_popup_notes"></div>
      <b-popover container="advisorNotesMenuPopup" target="advisorNotesDropDown" :show.sync='showAdvisorNotesDropDownDropDown' :no-fade='true' triggers="click" placement="'left'">
        <div class='header-content-row program'>
          <span class="title">Select Notes</span>
          <button class="btn_close" aria-label="close" @click="closeAdvisorNotesDropDown">
            <span class="ic-close"></span>
          </button>
        </div>

        <div class="channel_section">
          <template v-for="channel in channels">

            <template v-if="channel.type === 'personal'">
              <div class="card" style="cursor: pointer;" @click="viewAdvisorChannel(channel, 'Personal Notes On ' + streamOwnerName, $event)">
                <span class="ic ico-notes"></span>
                <div class="title">
                  <span>Personal Notes on</span>
                  <span class="usr_name" :title="streamOwnerName">{{streamOwnerName}}</span>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="card" style="cursor: pointer;" @click="viewAdvisorChannel(channel, 'Shared Notes On ' + streamOwnerName, $event)">
                <span class="ic ico-notes"></span>
                <span class="fas fa-users"></span>
                <div class="title">
                  <span>Shared Notes on</span>
                  <span class="usr_name" :title="streamOwnerName">{{streamOwnerName}}</span>
                </div>
              </div>
            </template>

          </template>
        </div>
      </b-popover>

      <template v-if="isShowAdvisorChannel">
        <advisor-channel :externalId="selectedChannel.externalId" :channelName="selectedChannelName"></advisor-channel>
      </template>
    </template>

    <!--<span class="icon-channel"></span>-->
    <!--<button class="btn icon-share2"></button>-->
    <!-- <span class="fas fa-exclamation-circle"></span> -->
    <!--<button class="btn" disabled>plan stream  <span class="circle"></span></button> -->

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import AdvisorChannel from '../../channel/components/AdvisorChannel'

export default {
  name: 'streamHeader',
  props: ['uuid', 'cipCode', 'returnTo', 'userId'],
  components: {
    AdvisorChannel
  },
  data: () => {
    return {
      userrole: localStorage.getItem('userrole'),
      READ_PERMISSION: 'ENTITY_READ_ONLY_PERMISSION',
      WRITE_PERMISSION: 'ENTITY_READ_WRITE_PERMISSION',
      SHARE_PERMISSION: 'ENTITY_READ_WRITE_SHARE_PERMISSION',
      instructorAdminRole: 'Instructor & Admin',
      studentRole: 'Student',
      lockStreamFlagName: 'lockStream',
      advisorNotesFlagName: 'advisorNotes',
      channels: [],
      streamOwnerName: '',
      selectedChannel: '',
      selectedChannelName: '',
      isShowAdvisorChannel: false,
      showAdvisorNotesDropDownDropDown: false
    }
  },

  mounted () {
    this.loadPermission()
    if(!this.userId){
      this.loadStreamDetail(this.uuid).then(stream => {
        if (this.userrole === 'Advisor' || this.userrole === 'Instructor') {
          this.populateAdvisorChannels(stream)
        }
      })
    }else{
      this.loadStreamDetailByUserId(this.userId).then(stream => {
        if (this.userrole === 'Advisor' || this.userrole === 'Instructor') {
          this.populateAdvisorChannels(stream)
        }
      })
    }
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'exportStreamToCsv',
      'loadPermission',
      'loadStreamDetail',
      'loadAdvisorChannels',
      'loadStreamDetailByUserId'
    ]),
    populateAdvisorChannels (stream) {
      this.channels = []
      if (stream) {
        this.streamOwnerName = stream.ownerName
        let externalIdStartWith = this.uuid + '-Advisor'
        this.loadAdvisorChannels(externalIdStartWith).then(dbChannels => {
          if (dbChannels && dbChannels.length > 0) {
            let sharedExternalId = this.uuid + '-Advisors'
            let personalExternalId = this.uuid + '-Advisor-Personal-' + this.userId
            dbChannels.forEach(dbChannel => {
              if ((dbChannel.externalId === sharedExternalId) || (dbChannel.externalId === personalExternalId)) {
                this.channels.push(dbChannel)
              }
            })
          }
        })
      }
    },
    navigateToProgramGuideView () {
      this.loadLogDashboardActivity({action: 'clickProgramGuideView', page: 'Program Guide View', link: 'Program Guide', entityUuid: this.uuid})
      return this.$router.push({ name: 'programGuide', params: { uuid: this.uuid } })
    },
    printScreen () {
      window.print()
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    writeFile (data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = this.csvFileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    exportStream () {
      this.exportStreamToCsv({uuid: this.uuid}).then(response => {
        let streamCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!streamCsvFile || !streamCsvFile.length || streamCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFile(streamCsvFile)
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Stream Successfully Exported to Csv')
        }
      })
    },
    editStreamClicked () {
      return this.$router.push({ name: 'planStream', params: { uuid: this.uuid } })
    },
    openAdvisorNotesDropDown () {
      this.showAdvisorNotesDropDownDropDown = true
    },
    closeAdvisorNotesDropDown () {
      this.showAdvisorNotesDropDownDropDown = false
    },
    viewAdvisorChannel (channel, name, event) {
      this.selectedChannel = channel
      this.selectedChannelName = name
      this.closeAdvisorNotesDropDown()
      this.isShowAdvisorChannel = true
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'advisorChannelModal', event.target)
      }, 250)
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'permission': state => state.user.permission,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    isStudent () {
      return this.userrole === this.studentRole
    },
    isInstructorAdmin () {
      return this.userrole === this.instructorAdminRole
    },
    advisorDashboardFeature () {
      return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
    },
    isLockStreamEnabled () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
        return false
      }
      let lockStreamFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.lockStreamFlagName)
      if (!lockStreamFlag) {
        return false
      }
      return lockStreamFlag.enabled || lockStreamFlag.isEnabled
    },
    csvFileName () {
      let stream = this.stream
      if (!stream || !stream.uuid || !stream.title) {
        return 'Advisor_Stream-Default.csv'
      }
      return 'Advisor_Stream-' + stream.title.split(' ').join('_') + '.csv'
    },
    streamExportFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_EXPORT
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    canExportStream () {
      let permission = this.permission
      let hasExportPermission = permission && permission.streamPermission && permission.streamPermission.export
      let isFeatureEnabled = this.streamExportFeatureMap && this.streamExportFeatureMap.enabled
      return hasExportPermission && isFeatureEnabled
    },
    showEditButton () {
      return this.isPlanStreamEnabled && this.canEditPlanningStream
    },
    isPlanStreamEnabled () {
      let planStreamFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_FEATURE_ID]
      if (planStreamFeature && planStreamFeature.enabled) {
        return true
      }
      return false
    },
    planStreamLabel () {
      let planStreamFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_FEATURE_ID]
      if (!planStreamFeature || !planStreamFeature.label) {
        return 'plan stream'
      }
      return planStreamFeature.label
    },
    ownerId () {
      let stream = this.stream
      return stream && stream.ownerId ? stream.ownerId : ''
    },
    accessControlList () {
      let stream = this.stream
      if (!stream || !stream.acelist) {
        return []
      }
      return stream.acelist
    },
    usersPermittedToEdit () {
      let users = this.ownerId && this.ownerId.length ? [this.ownerId] : []
      let accessControlList = this.accessControlList
      if (!accessControlList) {
        return users
      }
      const WRITE_PERMISSION = this.WRITE_PERMISSION
      const SHARE_PERMISSION = this.SHARE_PERMISSION
      accessControlList.forEach(accessControl => {
        let permission = accessControl.permission || {}
        let principal = accessControl.principal || {}
        let userIdList = principal.userUuidList
        let isEditPermission = permission.name === WRITE_PERMISSION || permission.name === SHARE_PERMISSION
        if (isEditPermission && userIdList) {
          userIdList.forEach(userId => {
            users.push(userId)
          })
        }
      })
      return users
    },
    canEditPlanningStream () {
      let showButton = false
      let usersPermittedToEdit = this.usersPermittedToEdit
      if (this.isInstructorAdmin) {
        return true
      }
      if (this.isStudent && this.isLockStreamEnabled) {
        return !this.stream.locked || !this.stream.isLocked
      }
      if (!usersPermittedToEdit || !usersPermittedToEdit.length) {
        return false
      }
      usersPermittedToEdit.forEach(userId => {
        if (userId === this.userId) {
          showButton = true
        }
      })
      return showButton
    },
    isAdvisorNotesEnabled () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
        return false
      }
      let advisorNotesFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.advisorNotesFlagName)
      if (!advisorNotesFlag) {
        return false
      }
      return advisorNotesFlag.enabled || advisorNotesFlag.isEnabled
    }
  },

  watch: {
  }
}
</script>
<style>
.stream-left-panel {
	.stream-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamHeader.vue